export const OVERLAY_TIME_DELAY = 400;

export const SHORTENED_URL = {
    MaxLength: 37,
    DefaultLength: 27,
    BeforeDotsLength: 10,
    AfterDotsLengthOffset: 14,
};
